@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  @if (title) {
    <h3 class="text-secondary mb-3 text-sm font-semibold uppercase tracking-wide">{{ title }}</h3>
  }

  @if (dataLoader) {
    <div class="flex items-center justify-center py-8">
      <mat-spinner diameter="32" color="primary" />
    </div>
  }

  @if (error && !dataLoader) {
    <div class="py-4 text-center text-sm text-red-500">{{ error }}</div>
  }

  @if (!dataLoader && !error && cards.length > 0) {
    <div
      class="grid gap-3"
      [ngClass]="{
        'grid-cols-2 sm:grid-cols-3 lg:grid-cols-7': columns === 7,
        'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6': columns === 6,
        'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5': columns === 5,
        'grid-cols-2 sm:grid-cols-4': columns === 4,
        'grid-cols-1 sm:grid-cols-3': columns === 3,
        'grid-cols-1 sm:grid-cols-2': columns === 2,
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4': columns === 0,
      }"
    >
      @for (card of cards; track card.label) {
        @if (card.route) {
          <a
            [routerLink]="card.route"
            [queryParams]="card.queryParams"
            class="flex cursor-pointer items-center gap-3 rounded-xl border bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
            [matTooltip]="card.subtitle ?? ''"
          >
            <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg" [ngClass]="card.bgColor">
              <mat-icon class="text-xl" [ngClass]="card.color">{{ card.icon }}</mat-icon>
            </div>
            <div class="min-w-0">
              <div class="text-default text-2xl font-bold leading-tight">
                @if (isNumber(card.value)) {
                  {{ card.value | number }}
                } @else {
                  {{ card.value }}
                }
              </div>
              <div class="text-secondary truncate text-xs">{{ card.label }}</div>
            </div>
            @if (card.trend) {
              <div
                class="ml-auto flex-shrink-0 text-xs font-medium"
                [ngClass]="{ 'text-green-600': card.trend === 'up', 'text-red-600': card.trend === 'down', 'text-secondary': card.trend === 'neutral' }"
              >
                {{ card.trendValue }}
              </div>
            }
          </a>
        } @else {
          <div class="flex items-center gap-3 rounded-xl border bg-white p-4 shadow-sm" [matTooltip]="card.subtitle ?? ''">
            <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg" [ngClass]="card.bgColor">
              <mat-icon class="text-xl" [ngClass]="card.color">{{ card.icon }}</mat-icon>
            </div>
            <div class="min-w-0">
              <div class="text-default text-2xl font-bold leading-tight">
                @if (isNumber(card.value)) {
                  {{ card.value | number }}
                } @else {
                  {{ card.value }}
                }
              </div>
              <div class="text-secondary truncate text-xs">{{ card.label }}</div>
            </div>
          </div>
        }
      }
    </div>
  }

  @if (!dataLoader && !error && cards.length === 0 && !widgetId) {
    <div class="text-secondary py-6 text-center text-sm">No data available</div>
  }
}
